import { takeEvery, all, put } from 'redux-saga/effects';
import { sendRequest } from 'redux-saga-requests';
import {
    fetchApplication,
    fetchAwardCategoryItem,
    fetchAwardItem,
    fetchChapterItem,
    fetchChapterMemberItem,
    fetchChapterDivisionItem,
    fetchFeedItem,
    fetchNewsItem,
    fetchRankItem,
    fetchEventItem,
    SOCKET_APPLICATION,
    SOCKET_AWARD,
    SOCKET_AWARD_CATEGORY,
    SOCKET_CHAPTER,
    SOCKET_CHAPTER_MEMBER,
    SOCKET_CHAPTER_DIVISION,
    SOCKET_DKP_EVENT,
    SOCKET_FEED,
    SOCKET_NEWS,
    SOCKET_RANK,
    fetchUser,
    SOCKET_USER,
    SOCKET_NOTIFICATION,
    fetchNotificationItem,
    fetchSectionStandingItem,
    SOCKET_DKP_STANDINGS,
    SOCKET_AWARD_RECIPIENT,
    SOCKET_POLL,
    fetchPolls,
    fetchScreenshotItem,
    fetchQuoteItem,
    SOCKET_SCREENSHOT,
    SOCKET_QUOTE,
    fetchResourceItem,
    fetchResourceContributionItem,
    SOCKET_DKP_RESOURCE,
    SOCKET_DKP_RESOURCE_CONTRIBUTION,
    fetchCodexItem,
    SOCKET_CODEX,
} from "./actions";

export function* socketSaga() {
    yield all([
        takeEvery(SOCKET_USER, socketUser),
        takeEvery(SOCKET_FEED, socketFeedItem),
        takeEvery(SOCKET_NEWS, socketNewsItem),
        takeEvery(SOCKET_APPLICATION, socketApplication),
        takeEvery(SOCKET_CHAPTER, socketChapter),
        takeEvery(SOCKET_CHAPTER_MEMBER, socketChapterMember),
        takeEvery(SOCKET_CHAPTER_DIVISION, socketChapterDivision),
        takeEvery(SOCKET_AWARD, socketAward),
        takeEvery(SOCKET_AWARD_CATEGORY, socketAwardCategory),
        takeEvery(SOCKET_RANK, socketRank),
        takeEvery(SOCKET_NOTIFICATION, socketNotification),
        takeEvery(SOCKET_DKP_EVENT, socketDKPEvent),
        takeEvery(SOCKET_DKP_STANDINGS, socketDKPStandings),
        takeEvery(SOCKET_AWARD_RECIPIENT, socketAwardRecipient),
        takeEvery(SOCKET_POLL, socketPoll),
        takeEvery(SOCKET_SCREENSHOT, socketScreenshot),
        takeEvery(SOCKET_QUOTE, socketQuote),
        takeEvery(SOCKET_DKP_RESOURCE, socketResource),
        takeEvery(SOCKET_DKP_RESOURCE_CONTRIBUTION, socketResourceContribution),
        takeEvery(SOCKET_CODEX, socketCodex),
    ])
}

function* socketUser(action) {
    yield put({type: 'FETCH_USER'});
    yield sendRequest(fetchUser(action.data.slug), { runOnSuccess: false, runOnError: false })
}


function* socketFeedItem(action) {
    yield put({type: 'FETCH_FEED_ITEM'});
    yield sendRequest(fetchFeedItem(action.data.id), { runOnSuccess: false, runOnError: false })
}

function* socketNewsItem(action) {
    yield put({type: 'FETCH_NEWS_ITEM'});
    yield sendRequest(fetchNewsItem(action.data.slug), { runOnSuccess: false, runOnError: false })
}

function* socketApplication(action) {
    yield put({type: 'FETCH_APPLICATION'});
    yield sendRequest(fetchApplication(action.data.id), { runOnSuccess: false, runOnError: false })
}

function* socketChapter(action) {
    yield put({type: 'FETCH_CHAPTER_ITEM'});
    yield sendRequest(fetchChapterItem(action.data.id), { runOnSuccess: false, runOnError: false })
}

function* socketChapterMember(action) {
    yield put({type: 'FETCH_CHAPTER_MEMBER_ITEM'});
    yield sendRequest(fetchChapterMemberItem(action.data.id, action.data.slug), { runOnSuccess: false, runOnError: false })
}

function* socketChapterDivision(action) {
    yield put({type: 'FETCH_CHAPTER_DIVISION_ITEM'});
    yield sendRequest(fetchChapterDivisionItem(action.data.id, action.data.slug), { runOnSuccess: false, runOnError: false })
}

function* socketAward(action) {
    yield put({type: 'FETCH_AWARD_ITEM'});
    yield sendRequest(fetchAwardItem(action.data.slug), { runOnSuccess: false, runOnError: false })
}

function* socketAwardCategory(action) {
    yield put({type: 'FETCH_AWARD_CATEGORY_ITEM'});
    yield sendRequest(fetchAwardCategoryItem(action.data.slug), { runOnSuccess: false, runOnError: false })
}

function* socketRank(action) {
    yield put({type: 'FETCH_RANK_ITEM'});
    yield sendRequest(fetchRankItem(action.data.slug), { runOnSuccess: false, runOnError: false })
}

function* socketNotification(action) {
    yield put({type: 'FETCH_NOTIFICATION_ITEM'});
    yield sendRequest(fetchNotificationItem(action.data.id), {runOnSuccess: false, runOnError: false})
}

function* socketDKPEvent(action) {
    yield put({type: 'FETCH_DKP_EVENT_ITEM'});
    yield sendRequest(fetchEventItem(action.data.slug, action.data.chapter, action.data.section), {runOnSuccess: false, runOnError: false})
}

function* socketDKPStandings(action) {
    yield put({type: 'FETCH_DKP_SECTION_STANDING_ITEM'});
    yield sendRequest(fetchSectionStandingItem(action.data.chapter, action.data.section, action.data.standing), {runOnSuccess: false, runOnError: false})
}

function* socketAwardRecipient(action) {

}

function* socketPoll(action) {
    yield put({type: 'FETCH_POLLS'});
    yield sendRequest(fetchPolls(action.data))
}

function* socketScreenshot(action) {
    yield put({type: 'FETCH_SCREENSHOT_ITEM'});
    yield sendRequest(fetchScreenshotItem(action.data))
}

function* socketQuote(action) {
    yield put({type: 'FETCH_QUOTE_ITEM'});
    yield sendRequest(fetchQuoteItem(action.data))
}

function* socketResource(action) {
    yield put({type: 'FETCH_DKP_RESOURCE_ITEM'})
    yield sendRequest(fetchResourceItem(action.data.chapter, action.data.section, action.data.resource))
}

function* socketResourceContribution(action) {
    yield put({type: 'FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM'})
    yield sendRequest(fetchResourceContributionItem(action.data.chapter, action.data.section, action.data.resource, action.data.id))
}

function* socketCodex(action) {
    yield put({type: 'FETCH_CODEX_ITEM'})
    yield sendRequest(fetchCodexItem(action.data.slug))
}


// WEBPACK FOOTER //
// ./src/redux/socketSagas.js